import React from "react";

const StatusInvestor = () => {
  return <div style={{ color: "white" }}>StatusInvestor</div>;
};

export default StatusInvestor;
